import { useTableLabelsOnMount } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/context/BroadcastScheduleProvider';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { LogotiposForm } from '@/features/logos/components/LogotiposForm';
import { useLogoFormPicker } from '@/features/logos/hooks/use-logo-form-picker';
import { TLogosForm } from '@/features/logos/types';
import { getAbsoluteDateFromPlayerTime } from '@/utils/hh-mm-ss-into-number';

import { useClipToolkitLogoFormState } from '../hooks/useClipToolkitLogoFormState';

export function ClipToolkitLogotiposForm() {
  const { activeClip, playerVideoCurrentTime, handleDateTimeClip, logoData, formBox } =
    useBroadcastScheduleProgram();
  const {
    form,
    isCreatingLogos,
    drawerLogo,
    handleClickExit,
    handleSubmit,
    handleSubmitLogo,
    renderAdditionalButtons,
  } = useClipToolkitLogoFormState();

  const labelsIn = useTableLabelsOnMount();
  const { picker, selectedLogo, selectCreatedLogo } = useLogoFormPicker({
    form,
    fallbackLabel: logoData?.entity_label,
    labelsIn,
    isActive: formBox === 'logo',
  });

  const handleClickAdd = () => {
    if (!activeClip?.start_datetime) return;

    const newDateTime = getAbsoluteDateFromPlayerTime(
      activeClip.start_datetime,
      playerVideoCurrentTime
    );

    form.setValue('start_datetime', newDateTime);
    form.setValue('end_datetime', newDateTime);
  };

  const handleCreateLogo = async (data: TLogosForm) => {
    const logo = await handleSubmitLogo(data);
    selectCreatedLogo(logo);
    return logo;
  };

  return (
    <LogotiposForm
      form={form}
      logoPicker={picker}
      selectedLogo={selectedLogo}
      isCreatingLogos={isCreatingLogos}
      drawerLogo={drawerLogo}
      handleClickAdd={handleClickAdd}
      handleClickExit={handleClickExit}
      handleSubmit={handleSubmit}
      handleSubmitLogo={handleCreateLogo}
      renderAdditionalButtons={renderAdditionalButtons}
      onClickTooltipDate={name => handleDateTimeClip(form, name)}
    />
  );
}
